module.exports = __webpack_public_path__ + "fonts/5d304f3e1a205725666b68578f47f90a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_channel.svg
// module id = 1527
// module chunks = 0